"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _FilledInput = _interopRequireDefault(require("../FilledInput"));
var _FormControl = _interopRequireDefault(require("../FormControl"));
var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _InputLabel = _interopRequireDefault(require("../InputLabel"));
var _createStyles = require("../styles/createStyles");
var _exposeClasses = require("../utilities/exposeClasses");
const _excluded = ["autoComplete", "autoFocus", "children", "className", "defaultValue", "disabled", "error", "expanded", "exposeClasses", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "type", "value", "variant", "classes"];
const variantComponent = {
  floating: _InputBase.default,
  filled: _FilledInput.default
};
const useStyles = (0, _createStyles.createStyles)({
  /* Styles applied to the root element. */
  root: {}
});
/**
 * **❗️ DEPRECATED**: Use the new `Input` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-input):
 *
 * ```tsx
 * import { Input } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-textfield--page)
 *
 * @deprecated
 */
const TextField = /*#__PURE__*/_react.default.forwardRef(function TextField(props, ref) {
  const {
      autoComplete,
      autoFocus = false,
      children,
      className,
      defaultValue,
      disabled = false,
      error = false,
      expanded = false,
      exposeClasses = false,
      fullWidth = false,
      helperText,
      hiddenLabel,
      id,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      multiline,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required = false,
      rows,
      type,
      value,
      variant = 'filled',
      classes: classesOverrides
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const labelRef = _react.default.useRef(null);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];
  const exposedClassesAttributes = exposeClasses ? (0, _exposeClasses.getExposedClasses)('DsTextField', classes, ['root']) : {};
  const InputElement = /*#__PURE__*/_react.default.createElement(InputComponent, (0, _extends2.default)({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete
    // eslint-disable-next-line jsx-a11y/no-autofocus -- TODO: [fix-jsx-a11y]
    ,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    exposeClasses: exposeClasses,
    fullWidth: fullWidth,
    name: name,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps,
    multiline: multiline,
    rows: rows
  }, InputProps));
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, (0, _extends2.default)({}, exposedClassesAttributes, {
    className: cx(classes.root, className),
    disabled: disabled,
    error: error,
    expanded: expanded,
    fullWidth: fullWidth,
    hasPlaceholder: !!placeholder,
    ref: ref,
    required: required,
    variant: variant
  }, other), label && /*#__PURE__*/_react.default.createElement(_InputLabel.default, (0, _extends2.default)({
    htmlFor: id,
    ref: labelRef,
    id: inputLabelId
  }, InputLabelProps), label), InputElement, helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    id: helperTextId
  }, helperText));
});
var _default = exports.default = TextField;